/** Точечная штриховка стены с неопределённым материалом. */
import { DotHatch, type WallHatchProps } from "./WallHatchGeometry";

export const OtherHatch = ({ outline }: WallHatchProps) => (
	<DotHatch outline={outline} spacing={7} />
);
